export default __webpack_public_path__ + "static/blog6-16003cd89200ac1408ecdd230be67d2b.jpg";